import axios from 'axios';
import { APICore } from './apiCore';

const api = new APICore();

interface ServiceDetails {
    name: string;
    description: string;
    discount: number;
    reviews: number;
    rating: number;
    imageUrl: string;
    price: number;
    media: MediaItem[];
}
interface MediaItem {
    name?: string;
    url: string;
    mediaType: string;
    isPrimary: boolean;
}

function getServices(params: { limit: number; page: number}) {
    const baseUrl = '/service';
    return api.get(`${baseUrl}`, params);
}
function addService(params: ServiceDetails) {
    const baseUrl = '/service';
    return api.create(`${baseUrl}`, params);
}

// Get service details
function getServiceDetails(params: { serviceId: string }) {
    const baseUrl = `/service/${params?.serviceId}`; // Adjust the endpoint URL as per your backend API
    return api.get(`${baseUrl}`, '');
}

// Update service details
function updateServiceDetails(params: {
    userId: any;
    id?: string;
    name?: string;
    description?: string;
    discount?: number;
    imageUrl: string;
    reviews: number;
    price: number;
    rating: number;
}) {
    const baseUrl = `/service/${params.id}`; // Adjust the endpoint URL as per your backend API
    const body: Record<string, any> = {};
    if (params.name !== undefined) body.name = params.name;
    if (params.imageUrl !== undefined) body.imageUrl = params.imageUrl;
    if (params.description !== undefined) body.description = params.description;
    if (params.discount !== undefined) body.discount = params.discount;
    if (params.reviews !== undefined) body.reviews = params.reviews;
    if (params.rating !== undefined) body.rating = params.rating;
    if (params.price !== undefined) body.price = params.price;
    return api.updatePatch(`${baseUrl}`, body);
}
function deleteServiceByIdApi(params: { serviceId: string }) {
    const baseUrl = `/service/${params.serviceId}`; // Adjust the endpoint URL as per your backend API
    return api.delete(`${baseUrl}`);
}
export { getServices, addService, getServiceDetails, updateServiceDetails, deleteServiceByIdApi };
